export enum DocumentCustomForm {
  CreateClaim = 'AssociatePatientEOC',
  AssignToEntryUserAndSend = 'AssignToEntryUserAndSend',
  SupplementalDocumentation = 'SupplementalDocumentation',
}
